/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DocBits - API
 * DocBits - API
 * OpenAPI spec version: 11.97.2
 */
import type { BodyCreateSupportTicketSupportCreateSupportTicketPost } from '.././models';

import { customAxiosInstance } from '../../mutator/custom-axios-instance';

export const getSupport = () => {
  /**
   * @summary Create Support Ticket
   */
  const createSupportTicketSupportCreateSupportTicketPost = (
    bodyCreateSupportTicketSupportCreateSupportTicketPost: BodyCreateSupportTicketSupportCreateSupportTicketPost,
  ) => {
    const formData = new FormData();
    if (
      bodyCreateSupportTicketSupportCreateSupportTicketPost.org_id !==
        undefined &&
      bodyCreateSupportTicketSupportCreateSupportTicketPost.org_id !== null
    ) {
      formData.append(
        `org_id`,
        bodyCreateSupportTicketSupportCreateSupportTicketPost.org_id,
      );
    }
    formData.append(
      `customer_email`,
      bodyCreateSupportTicketSupportCreateSupportTicketPost.customer_email,
    );
    if (
      bodyCreateSupportTicketSupportCreateSupportTicketPost.subject !==
      undefined
    ) {
      formData.append(
        `subject`,
        bodyCreateSupportTicketSupportCreateSupportTicketPost.subject,
      );
    }
    formData.append(
      `fullname`,
      bodyCreateSupportTicketSupportCreateSupportTicketPost.fullname,
    );
    formData.append(
      `body`,
      bodyCreateSupportTicketSupportCreateSupportTicketPost.body,
    );
    if (
      bodyCreateSupportTicketSupportCreateSupportTicketPost.priority !==
      undefined
    ) {
      formData.append(
        `priority`,
        bodyCreateSupportTicketSupportCreateSupportTicketPost.priority,
      );
    }
    if (
      bodyCreateSupportTicketSupportCreateSupportTicketPost.attachment !==
      undefined
    ) {
      formData.append(
        `attachment`,
        bodyCreateSupportTicketSupportCreateSupportTicketPost.attachment,
      );
    }
    if (
      bodyCreateSupportTicketSupportCreateSupportTicketPost.screenshot !==
      undefined
    ) {
      formData.append(
        `screenshot`,
        bodyCreateSupportTicketSupportCreateSupportTicketPost.screenshot,
      );
    }

    return customAxiosInstance<unknown>({
      url: `/support/create_support_ticket`,
      method: 'POST',
      headers: { 'Content-Type': 'multipart/form-data' },
      data: formData,
    });
  };
  return { createSupportTicketSupportCreateSupportTicketPost };
};
export type CreateSupportTicketSupportCreateSupportTicketPostResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof getSupport
        >['createSupportTicketSupportCreateSupportTicketPost']
      >
    >
  >;
